import { connect } from 'react-redux';

import LearningModuleFilters from '../components/LearningModuleFilters';

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningModuleFiltersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModuleFilters);

export default LearningModuleFiltersContainer;
